export function assetUrl(assetsSubPath) {
  if (assetsSubPath.startsWith('/')) assetsSubPath = assetsSubPath.slice(1);
  return "/assets/extensions/choina-baner/".concat(assetsSubPath);
}
flarum.reg.add('choina-pomagam-parafialnie', 'common/utils/assets', { assetUrl: assetUrl, });